module.exports = __webpack_public_path__ + "f9a25466e5ac752f14dfa013fad9730a.jpg";